"use client";
import * as React from "react";
const SvgLogoutRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M11.78 3.66a.76.76 0 0 0 0 1.09l1.52 1.48H5.93c-.44 0-.8.35-.8.78s.36.78.8.78h7.37l-1.52 1.48c-.31.3-.31.79 0 1.09s.8.3 1.12 0l2.87-2.79a.77.77 0 0 0 0-1.1l-2.87-2.8a.8.8 0 0 0-1.12 0zM1.6 1.56h5.6c.44 0 .8-.35.8-.78S7.64 0 7.2 0H1.6C.72 0 0 .7 0 1.56v10.88C0 13.3.72 14 1.6 14h5.6c.44 0 .8-.35.8-.78s-.36-.78-.8-.78H1.6z" }));
export {
  SvgLogoutRound as default
};
